import { useState } from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

import Typography from "@mui/material/Typography";
import QueryRunnner from "./QueryRunnner/QueryRunnner";
import History from "./History/History";
import FranchiseData from "./FranchiseData/FranchiseData";
import COFOPaymentWorking from "./COFOPaymentWorking/COFOPaymentWorking";

//for tab section
function a11yProps(index) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
		value: index,
	};
}
const tabStyle = { textTransform: "capitalize", fontSize: "16px", width: "170px" };

const EBOPayments = () => {
	const [tab, setTab] = useState(0);
	const [history, setHistory] = useState();

	const handleTabChange = (event, newValue) => {
		setTab(newValue);
	};

	return (
		<Stack maxWidth="1900px" width="90vw" margin="auto" spacing={2}>
			<Typography variant="h4" width="100%" pt={4}>
				Franchise Payments
			</Typography>
			<Box height="450px">
				<Tabs
					value={tab}
					onChange={handleTabChange}
					aria-label="basic tabs example"
					sx={{ borderBottom: 1, borderColor: "divider" }}>
					<Tab sx={tabStyle} label="Franchise Data" {...a11yProps(0)} />
					{/* <Tab sx={tabStyle} label="Franchise Master" {...a11yProps(1)} /> */}
					<Tab sx={tabStyle} label="FOFO Reports" {...a11yProps(1)} />
					<Tab sx={tabStyle} label="COFO Reports" {...a11yProps(2)} />
					{/* <Tab sx={tabStyle} label="History" {...a11yProps(4)} /> */}
				</Tabs>
				<Box display={tab === 0 ? "block" : "none "}>
					<FranchiseData history={history} setHistory={setHistory} />
				</Box>
				<Box display={tab === 1 ? "block" : "none "}>
					<QueryRunnner history={history} setHistory={setHistory} />
				</Box>
				<Box display={tab === 2 ? "block" : "none "}>
					<COFOPaymentWorking history={history} setHistory={setHistory} />
				</Box>
				{/* <Box display={tab === 2 ? "block" : "none "}>
					<History />
				</Box> */}
			</Box>
		</Stack>
	);
};

export default EBOPayments;
